export class MyError<C extends string | number = string | number> extends Error {
  code: C | undefined;
  data: any;
  constructor(
    msg:
      | {
          message?: string;
          code?: C;
          errorMessage?: string;
          errorCode?: C;
        }
      | string
      | number,
    data?: any
  ) {
    let message: string | undefined;
    let code: C | undefined = undefined;

    if (msg) {
      switch (typeof msg) {
        case 'object':
          message = msg.message ?? msg.errorMessage;
          code = msg.code ?? msg.errorCode;
          break;
        case 'string':
          message = msg;
          break;
        case 'number':
          code = msg as C;
          break;
        default:
          break;
      }
    }

    super(message || 'Unknown error.');

    if (typeof code !== 'undefined') {
      this.code = code;
    }

    this.data = data ?? msg;
  }
}
